import { Translation } from '@ps/web-shared-components';
import classNames from 'clsx';
import React from 'react';

import { Icon } from '@swf/sports/components';
import type { EventTypeId } from '@swf/sports/types/eventType';
import { getEventTypeIcon } from '@swf/sports/utils/getEventTypeIcon';

import {
  TXTWCL_Dead_heat_Xshort_formX,
  TXTWCL_In_Play_Xshort_formX
} from './EventTypeIcon.messages.json';
import styles from './EventTypeIcon.scss';

interface Props {
  isInPlay?: boolean;
  eventTypeId?: EventTypeId;
  isDeadHeat?: boolean;
  isSgm?: boolean;
}

const EventTypeIcon: React.FC<Props> = ({ isInPlay, eventTypeId, isDeadHeat, isSgm }) => {
  let iconName = getEventTypeIcon(eventTypeId);
  if (isSgm) {
    iconName = 'bet-builder';
  }

  return (
    <div
      className={classNames(styles.wrapper, {
        [styles.inPlay]: isInPlay,
        [styles.deadHeat]: isDeadHeat,
        [styles.sgm]: isSgm
      })}
    >
      <Icon name={iconName} className={styles.icon} size="x2.5" />

      <span>
        {isInPlay ? (
          <Translation {...TXTWCL_In_Play_Xshort_formX} />
        ) : isDeadHeat ? (
          <Translation {...TXTWCL_Dead_heat_Xshort_formX} />
        ) : null}
      </span>
    </div>
  );
};

export default EventTypeIcon;
